import { UserProfile } from "generated/graphql";
import { useSelector } from "react-redux";
import { State } from "redux/state";

export function useProfile() {
    return useSelector<State, UserProfile>(state => state.auth.profile);
}
